export const outerContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'auto',
}

export const containerStyles = {
  display: 'flex',
  flexDirection: ['column', 'column', 'row'],
  alignItems: 'start',
  justifyContent: ['start'],
  width: '100%',
  textAlign: ['center', 'center', 'start'],
}

export const textContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: ['0px', '0px', '10px'],
  justifyContent: 'start',
  alignItems: ['center', 'center', 'start'],
  alignSelf: 'center',
  maxWidth: '82%',
}
